<template>
  <div>
    <h6 style="margin: 0px !important">{{ GECIKENSENETTOPLAM }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ PUANGSENET }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      GECIKENSENETTOPLAM: 0.0,
      PUANGSENET: 0.0,
    };
  },
  methods: {
    gelenData() {
      this.GECIKENSENETTOPLAM = this.currencyFormatter(
        this.params.data.GECIKENSENETTOPLAM,
        "₺"
      );
      this.PUANGSENET = this.currencyFormatter(
        this.params.data.PUANGSENET,
        " "
      );
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return 0.0;
      } else {
        var parfloat = parseFloat(currency);
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
